import Color from 'color';
import { orange } from 'pages/Hospitality/components/Rooms.styled';
import { lFColor } from 'pages/components/LFHeader/LFHeader.styled';
import styled from 'styled-components';

const alertAccent = '#c45c26';

export const Container = styled.div`
  position: relative;
  z-index: 1;
  width: 100%;
  min-height: 58px;
  background: ${Color(alertAccent).lighten(0.72).toString()};
  border-bottom: 1px solid ${Color(alertAccent).lighten(0.55).toString()};
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  color: ${Color(alertAccent).darken(0.35).toString()};
  flex-shrink: 0;
`;

export const WarnIcon = styled.div`
  display: flex;
  align-items: center;
  color: ${Color(alertAccent).darken(0.1).toString()};
  flex-shrink: 0;
`;

export const Body = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 3px;
`;

/** Line 1 — short explanation of why this strip is showing. */
export const Title = styled.div`
  font-size: 12.5px;
  font-weight: 700;
  line-height: 1.3;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Line = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 8px;
  min-width: 0;
  overflow: hidden;
`;

export const Chip = styled.div<{ accent?: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  max-width: 100%;
  font-size: 12.5px;
  font-weight: ${({ accent }) => (accent ? 700 : 600)};
  color: ${({ accent }) => (
    accent ? Color(alertAccent).darken(0.45).toString() : 'inherit'
  )};
`;

export const ChipText = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: min(220px, 36vw);
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
  flex-shrink: 0;
`;

export const ViewAllBtn = styled.button`
  height: 30px;
  padding: 0 10px;
  border-radius: 6px;
  border: 1.5px solid ${Color(lFColor).alpha(0.35).toString()};
  background: white;
  color: ${lFColor};
  font-size: 11.5px;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
  &:hover {
    background: ${Color(lFColor).alpha(0.06).toString()};
  }
`;

export const DismissBtn = styled.button`
  height: 30px;
  padding: 0 10px;
  border-radius: 6px;
  border: 1.5px solid ${Color(alertAccent).alpha(0.45).toString()};
  background: white;
  color: ${Color(alertAccent).darken(0.25).toString()};
  font-size: 11.5px;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  &:hover {
    background: ${Color(alertAccent).alpha(0.08).toString()};
  }
`;

export const Nav = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
`;

export const NavBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  color: inherit;
  cursor: pointer;
  padding: 2px;
  border-radius: 3px;
  &:hover {
    color: ${orange};
    background: ${Color(alertAccent).alpha(0.12).toString()};
  }
`;

export const Count = styled.div`
  font-size: 11px;
  font-weight: 600;
  min-width: 28px;
  text-align: center;
`;
